module.exports = __webpack_public_path__ + "01_glasses_red.76ffa30d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer4/01_glasses_red.png
// module id = pPCE
// module chunks = 0